import React from 'react'

import { Modal, Button, Table } from '_zari/core'

const TablaDetallesModal = ({ handleClose, show, modalData }) => {
  return (
    <Modal size='md' show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Detalles Consumo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          className='text-center'
          filas={modalData}
          maxRowsShown={10}
          headRows={[
            {
              label: 'FECHA'
            },
            {
              label: 'TIPO'
            },
            {
              label: 'SERIE'
            },
            {
              label: 'NUMERO'
            },
            {
              label: 'CANTIDAD'
            },
            {
              label: 'CENTRO COSTO 2'
            }
          ]}
          rowTemplate={(row, key) => (
            <Table.Row key={key}>
              <Table.Cell className='text-center'>{row.fecha}</Table.Cell>
              <Table.Cell className='text-center'>{row.tipo}</Table.Cell>
              <Table.Cell className='text-center'>{row.serie}</Table.Cell>
              <Table.Cell className='text-center'>{row.numero}</Table.Cell>
              <Table.Cell className='text-center'>{row.cantidad}</Table.Cell>
              <Table.Cell className='text-center'>{row.centroCosto}</Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(TablaDetallesModal)
